import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../Component/Baseurl';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCheckCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';

function FollowEvent({ eventUniqueId }) {
    const [isFollowed, setIsFollowed] = useState(false);  // State to track if the event is already followed
    const [isLoading, setIsLoading] = useState(false);  // State to track loading state


    let userId = localStorage.getItem("visitor_id"); // Get the user_id from localStorage
    // console.log("User ID from localStorage:", userId);

    useEffect(() => {
        const checkFollowStatus = async () => {
            try {
                const response = await axios.post(`${BASE_URL}check_follow_status`, {
                    user_id: userId,  // Replace with actual user ID from auth logic
                    event_unique_id: eventUniqueId,
                });

                // Check the response to determine if already followed
                if (response.data.message === "You have already followed this event") {
                    setIsFollowed(true);  // Set state to true if already followed
                }
            } catch (error) {
                console.log("Error checking follow status:", error);
                toast.error("Error checking follow status");
            }
        };

        if (userId) {
            checkFollowStatus();  // Call the checkFollowStatus function on component mount if user is logged in
        }
    }, [eventUniqueId, userId]);  // Dependency array to re-run the effect when eventUniqueId or userId changes

    const handleFollowEvent = async () => {
        // If user is not logged in, store the current URL and redirect to login
        if (!userId) {
            localStorage.setItem('redirectUrl', window.location.href);  // Store the current URL
            console.log('Redirect URL stored:', window.location.href);  // Log the URL
            window.location.href = '/login';  // Redirect to login page
            return;  // Exit the function so the API call doesn't happen
        }

        setIsLoading(true);  // Start loading animation

        try {
            const response = await axios.post(`${BASE_URL}follow_event`, {
                user_id: userId,  // Replace with actual user ID from auth logic
                event_unique_id: eventUniqueId,
            });

            console.log("API Response:", response.data);
            toast.success(response.data.message);
            window.location.reload();

            // Simulate a delay for the "Following" animation (1 second)
            setTimeout(() => {
                setIsFollowed(true);  // Update state to reflect that the event has been followed
                setIsLoading(false);  // Stop loading animation
            }, 1000);  // Delay of 1 second
        } catch (error) {
            setIsLoading(false);  // Stop loading animation if error occurs
            if (error.response && error.response.data) {
                console.log("API Error Response:", error.response.data);
                toast.error(error.response.data.message);
            } else {
                console.log("Error following event");
                toast.error("Error following event");
            }
        }
    };

    return (
         
        
            <span 
                className="followbtn1" 
                onClick={handleFollowEvent}
                disabled={isFollowed || isLoading}  // Disable the button if already followed or loading
            >
                {isLoading ? (
                    <>Following <FontAwesomeIcon icon={faSpinner} spin /> </>  // Show "Following" text with spinner
                ) : isFollowed ? (
                    <>Followed <FontAwesomeIcon icon={faCheckCircle} /> </>  // Show "Already Followed" text with check icon
                ) : (
                    <>Follow Event <FontAwesomeIcon icon={faArrowRight} /> </>  // Show default "Follow Event" text with arrow icon
                )}
            </span>
         
    );
}

export default FollowEvent;
